<template>
  <div class="image-fullscreen-container" @click.self="closeView">
    <button type="button" class="close-button font-size-big" @click="closeView">
      <font-awesome-icon icon="times"/>
    </button>
    <img :src="imageSrc"
         alt="Lyrics image"
         class="image"
         :class="{ 'zoomed-in' : zoomedIn }"
         :style="imageInitialStyle"
         ref="image"
         @click="handleZoom"
         draggable="false">
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
} from '@fortawesome/free-solid-svg-icons'

library.add(faTimes)

export default {
  name: 'ImageFullScreen',
  props: {
    imageSrc: {
      required: false
    }
  },
  data () {
    return {
      imageInitialStyle: null,
      zoomedIn: false,
      zoomScale: 1.5,
      isDragging: false,
      isMoving: false,
      dragStart: {}
    }
  },
  mounted () {
    document.addEventListener('keydown', this.escapeKeyCloseView)
    this.$refs.image.addEventListener('mousedown', this.handleDragStart)
    this.$refs.image.addEventListener('touchstart', this.handleDragStart)
    this.$refs.image.addEventListener('mousemove', _.throttle(this.handleDragMove, 16), false)
    this.$refs.image.addEventListener('touchmove', _.throttle(this.handleDragMove, 16), false)
    this.$refs.image.addEventListener('mouseup', this.handleDragStop)
    this.$refs.image.addEventListener('touchend', this.handleTouchDragStop)

    this.imageInitialStyle = {
      maxHeight: '100vh',
      maxWidth: '100vw',
      width: `auto`,
      height: `auto`,
      top: 'calc(50%)',
      left: 'calc(50%)',
      transition: 'width 0.2s, height 0.2s, max-width 0.2s, max-height 0.2s'
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.escapeKeyCloseView)
    this.$refs.image.removeEventListener('mousedown', this.handleDragStart)
    this.$refs.image.removeEventListener('touchstart', this.handleDragStart)
    this.$refs.image.removeEventListener('mousemove', _.throttle(this.handleDragMove, 16), false)
    this.$refs.image.removeEventListener('touchmove', _.throttle(this.handleDragMove, 16), false)
    this.$refs.image.removeEventListener('mouseup', this.handleDragStop)
    this.$refs.image.removeEventListener('touchend', this.handleTouchDragStop)
  },
  methods: {
    closeView () {
      this.$emit('closeFullScreen')
    },
    escapeKeyCloseView (event) {
      if (event.keyCode === 27 || event.code === 'Escape') {
        this.closeView()
      }
    },
    handleZoom (e) {
      if (!this.isMoving) {
        this.$refs.image.style.transition = `${this.imageInitialStyle.transition}, left 0.2s, top 0.2s`
        if (!this.zoomedIn) {
          const zoomLocationX = e.clientX - this.$refs.image.offsetLeft
          const zoomLocationY = e.clientY - this.$refs.image.offsetTop
          this.$refs.image.style.left = `calc(50% - ${zoomLocationX}px)`
          this.$refs.image.style.top = `calc(50%  - ${zoomLocationY}px)`

          this.$refs.image.style.height = `${this.$refs.image.getBoundingClientRect().height}px`
          this.$refs.image.style.width = `${this.$refs.image.getBoundingClientRect().width}px`
          this.$refs.image.style.height = this.$refs.image.style.maxHeight =
              `${Math.floor(this.$refs.image.getBoundingClientRect().height * this.zoomScale)}px`
          this.$refs.image.style.width = this.$refs.image.style.maxWidth =
              `${Math.floor(this.$refs.image.getBoundingClientRect().width * this.zoomScale)}px`

        } else {
          this.$refs.image.style.maxWidth = this.imageInitialStyle.maxWidth
          this.$refs.image.style.maxHeight = this.imageInitialStyle.maxHeight
          this.$refs.image.style.width = this.imageInitialStyle.width
          this.$refs.image.style.height = this.imageInitialStyle.height
          this.$refs.image.style.left = this.imageInitialStyle.left
          this.$refs.image.style.top = this.imageInitialStyle.top
          this.isDragging = false
        }
        setTimeout(() => {
          this.$refs.image.style.transition = this.imageInitialStyle.transition
        }, 200)
        this.zoomedIn = !this.zoomedIn
      }
      this.isMoving = false
    },
    handleDragStart (e) {
      this.dragStart.x = (e.clientX || e.touches?.[0].clientX) - this.$refs.image.offsetLeft
      this.dragStart.y = (e.clientY || e.touches?.[0].clientY) - this.$refs.image.offsetTop
      if (this.zoomedIn) {
        this.isDragging = true
      }
    },
    handleDragMove (e) {
      if (this.isDragging) {
        this.isMoving = true
        this.$refs.image.style.left = `${(e.clientX || e.touches?.[0].clientX) - this.dragStart.x}px`
        this.$refs.image.style.top = `${(e.clientY || e.touches?.[0].clientY) - this.dragStart.y}px`
      }
    },
    handleDragStop (e) {
      if (this.isDragging && this.isMoving) {
        this.isDragging = false
      }
    },
    handleTouchDragStop (e) {
      if (this.isDragging) {
        this.isDragging = false
        this.isMoving = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.image-fullscreen-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.80);

  button.close-button {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 10px;
    top: 10px;
    background-color: unset;
    border: none;
    padding: 0;
    cursor: pointer;
    color: $grey-light;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 4;
  }

  .image {
    max-height: 100vh;
    max-width: 100vw;
    cursor: zoom-in;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
    z-index: 3;
  }

  .zoomed-in {
    cursor: zoom-out;
  }
}

</style>